import React from "react";
import { BaseControlQuestionProps } from "./type";
import { TextQuestion as TextQuestionType } from "@shared/types";
import { Question } from "../question";
import { Input } from "component-library";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const TextQuestion: React.FC<
  BaseControlQuestionProps & Omit<TextQuestionType, "type" | "required">
> = ({ position, id, question, control, required }) => {
  const { i18n } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      position={position}
      direction="column"
    >
      <Controller
        name={id}
        control={control}
        rules={{ required }}
        render={({ field, fieldState }) => (
          <Input
            error={fieldState.error?.message}
            value={field.value}
            onChange={field.onChange}
          />
        )}
      />
    </Question>
  );
};
